import device from './browser-detection';
import updateSVGs from 'svg4everybody';

if (device.browser.ie) {
  updateSVGs();
}
